import {useState, useEffect} from "preact/compat"
import { 
    accountEditIcon, 
    addressIcon, 
    beneficiaryIcon, 
    ordersIcon, 
    passwordIcon 
} from "../../../assets";

export const useLoggedMenu = () => {
    // Flags the menu open state
    const [menuFocus, setMenuFocus] = useState(false); 

    const items = [
        {label: 'MEUS PEDIDOS', icon: ordersIcon, href: '/meus-pedidos'},
        {label: 'MEUS DADOS', icon: accountEditIcon, href: '/editar-conta'},
        {label: 'ENDEREÇOS', icon: addressIcon, href: '/enderecos'},
        {label: 'BENEFICIÁRIOS', icon: beneficiaryIcon, href: '/beneficiarios'},
        {label: 'ALTERAR SENHA', icon: passwordIcon, href: '/senha'},
    ];

    // Handles the menu focus state
    const handleMenuFocus = () => {
        setMenuFocus((prevState) => !prevState);
    }

    // Controls the body overflow when the menu is focused
    useEffect(() => {
        if (menuFocus) {
            document.body.classList.add("overflow-deactivate");
        } else {
            document.body.classList.remove("overflow-deactivate");
        }
    }, [menuFocus]);
    
    return {
        items,
        menuFocus,
        handleMenuFocus
    }
}